(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["badv-offer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function wire(source) {
      if (source.dataset.wired) return;
      source.dataset.wired = '1';

      var rail = document.querySelector('.badv-rail');
      if (!rail) return;

      while (source.firstChild) {
        rail.appendChild(source.firstChild);
      }
      source.remove();
    }

    function scan() {
      document.querySelectorAll('[data-badv-rail-source]').forEach(wire);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scan);
    } else {
      scan();
    }

    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bed199-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function wire(bar) {
      if (bar.dataset.wired) return;
      bar.dataset.wired = '1';

      var trigger = document.getElementById(bar.dataset.revealAfter || '');
      var offer = document.getElementById(bar.dataset.hideOver || '');
      var ratio = parseFloat(bar.dataset.revealRatio);
      if (isNaN(ratio)) ratio = 0.35;

      if (!trigger) {
        bar.hidden = false;
        return;
      }

      var paint = function () {
        var top = trigger.getBoundingClientRect().top + window.scrollY;
        var read = window.scrollY > top - window.innerHeight * ratio;
        var overOffer = false;
        if (offer) {
          var r = offer.getBoundingClientRect();
          overOffer = r.top < window.innerHeight && r.bottom > 0;
        }
        bar.hidden = !(read && !overOffer);
      };

      paint();
      addEventListener('scroll', paint, { passive: true });
      addEventListener('resize', paint, { passive: true });
    }

    function scan() {
      document.querySelectorAll('[data-b199-sticky]').forEach(wire);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scan);
    } else {
      scan();
    }

    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bed8r-buybox"] && !Shopify.designMode) return;
  try {
    
  /* Buy box: colour = product, size = variant of that product.
     Changing colour swaps the gallery, the price block, the size buttons and
     the checkout link. Changing size swaps the price block and the link.
     The initial state is rendered server-side, so the default colour works
     with JS off; this only takes over on interaction. */
  (function () {
    /* Diagnostics. Off unless the page is loaded with ?b8r_debug=1 or the
       section's "Debug logging" setting is on. Genuine faults (a payload that
       will not parse, a control with nothing behind it) warn regardless,
       because each of those silently disables part of the buy box. */
    var DEBUG = false;
    try {
      DEBUG = /[?&]b8r_debug(=1)?(&|$)/.test(window.location.search);
    } catch (e) {}

    function log() {
      if (!DEBUG) return;
      var a = Array.prototype.slice.call(arguments);
      a.unshift('%c[b8r-buybox]', 'color:#0a00b4;font-weight:700');
      console.log.apply(console, a);
    }
    function warn() {
      var a = Array.prototype.slice.call(arguments);
      a.unshift('[b8r-buybox]');
      console.warn.apply(console, a);
    }

    function parseData(root) {
      var all = document.querySelectorAll('[data-b8r-colour-data]');
      var tag = root.querySelector('[data-b8r-colour-data]');
      console.log('[b8r-buybox]', all)
      if (all.length !== 1) {
        warn('expected exactly 1 colour payload on the page, found ' + all.length +
             '. querySelector takes the first inside this section, which may be the wrong one.');
      }
      if (!tag) {
        warn('no [data-b8r-colour-data] script tag inside this section — colour ' +
             'switching is dead. Payloads elsewhere on the page: ' + all.length);
        return null;
      }

      var raw = tag.textContent;
      try {
        var parsed = JSON.parse(raw);
        var type = Object.prototype.toString.call(parsed);
        log('payload parsed', {
          type: type,
          keys: (parsed && typeof parsed === 'object') ? Object.keys(parsed) : '(not an object)',
          bytes: raw.length
        });
        if (parsed && typeof parsed === 'object' && !parsed.swatches && parsed.colors) {
          /* Rewritten in flight by qwetranlator(). Recover rather than die. */
          warn('payload key was rewritten from "swatches" to "colors" by a ' +
               'text-node replacer — recovering. If you see this, a script is ' +
               'still rewriting JSON on this page.');
          parsed.swatches = parsed.colors;
        }
        if (!parsed || typeof parsed !== 'object' || !parsed.swatches) {
          /* Parsed, but not the shape this section emits. Print everything
             needed to see what actually came back. */
          warn('payload parsed but has no "colours" key. This is not the object ' +
               'this section emits, so something is rewriting or replacing the tag.');
          warn('  parsed type :', type);
          warn('  parsed keys :', (parsed && typeof parsed === 'object') ? Object.keys(parsed) : '(none)');
          warn('  parsed value:', parsed);
          warn('  raw length  :', raw.length);
          warn('  raw first 600:', raw.slice(0, 600));
          warn('  raw last  300:', raw.slice(-300));
          warn('  tag parent  :', tag.parentNode && tag.parentNode.tagName +
               '.' + (tag.parentNode.className || ''));
          warn('  tag attrs   :', Array.prototype.map.call(tag.attributes, function (a) {
            return a.name + '="' + a.value + '"';
          }).join(' '));
        }
        return parsed;
      } catch (e) {
        /* This is the failure that produces both reported symptoms at once:
           fabric unclickable AND sizes not changing. Print the offending text
           so the bad character can be found. */
        warn('colour payload did not parse — fabric and size switching are disabled.', e);
        warn('payload was:', tag.textContent);
        return null;
      }
    }

    /* Mirrors the server: the variant whose title matches the preferred name
       (exact first, then a loose contains), else the last available variant,
       else the last variant. Sizes run small -> large, so falling back to the
       last one lands on the biggest rather than the smallest. */
    /* Shopify money_format placeholders, same set option_selection.js handles.
       Needed because the payload's price strings are pre-formatted markup and a
       difference can only be computed from the numeric minor units. */
    function formatMoney(cents, format) {
      if (typeof cents !== 'number' || isNaN(cents)) return '';
      var placeholder = /\{\{\s*(\w+)\s*\}\}/;

      function num(n, precision, thousands, decimal) {
        var fixed = (Math.abs(n) / 100).toFixed(precision);
        var parts = fixed.split('.');
        var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        return parts[1] ? whole + decimal + parts[1] : whole;
      }

      /* No shop format available: a bare number is better than nothing.
         The literal placeholder is deliberately not written out anywhere in
         this block — Liquid-looking syntax in a section javascript block is
         flagged by theme check, and would be a trap if it were ever rendered. */
      var fmt = format || '';
      if (!fmt) return num(cents, 2, ',', '.');

      var match = fmt.match(placeholder);
      var name = match ? match[1] : 'amount';
      var value;
      switch (name) {
        case 'amount_no_decimals':                    value = num(cents, 0, ',', '.'); break;
        case 'amount_with_comma_separator':           value = num(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = num(cents, 0, '.', ','); break;
        case 'amount_with_apostrophe_separator':      value = num(cents, 2, "'", '.'); break;
        case 'amount_with_space_separator':           value = num(cents, 2, ' ', ','); break;
        case 'amount_no_decimals_with_space_separator': value = num(cents, 0, ' ', ','); break;
        default:                                      value = num(cents, 2, ',', '.');
      }
      /* strip any markup the format carries (this shop wraps in <span class=money>) */
      return fmt.replace(placeholder, value).replace(/<[^>]+>/g, '').trim();
    }

    function preferredVariant(variants, preferred) {
      var exact = null;
      var loose = null;
      var lastAvailable = null;
      var name = (preferred || '').toLowerCase();

      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (!v.available) continue;
        lastAvailable = v;
        var title = String(v.title || '').toLowerCase();
        if (!exact && name && title === name) exact = v;
        if (!loose && name && title.indexOf(name) !== -1) loose = v;
      }
      return exact || loose || lastAvailable || variants[variants.length - 1] || null;
    }

    function wire(root) {
      if (root.dataset.b8rWired) return;
      root.dataset.b8rWired = '1';

      var data = parseData(root);

      /* Remove the unopenable How To Use modal that the size-guide snippet
         emits. Done here, inside wire(), so it only ever runs on a page that
         renders this buy box — the product pages keep theirs. */
      var howTo = document.getElementById('howToUseModal');
      if (howTo && howTo.parentNode) howTo.parentNode.removeChild(howTo);

      var main = root.querySelector('.b8r-gallery__main img');
      var thumbWrap = root.querySelector('[data-b8r-thumbs]');
      var sizeWrap = root.querySelector('[data-b8r-sizes]');
      var swatchWrap = root.querySelector('[data-b8r-swatches]');
      var fabricWrap = root.querySelector('[data-b8r-fabrics]');
      var ratingWrap = root.querySelector('[data-b8r-rating]');
      var priceEl = root.querySelector('[data-price]');
      var compareEl = root.querySelector('[data-price-compare]');
      var pillEl = root.querySelector('[data-discount-pill]');
      var cta = root.querySelector('[data-add-to-cart]');
      var ctaLabel = root.querySelector('[data-cta-label]');

      /* ---- gallery: thumbnail click swaps the main image ---- */
      function bindThumbs() {
        if (!thumbWrap) return;
        var thumbs = Array.prototype.slice.call(
          thumbWrap.querySelectorAll('.b8r-gallery__thumb')
        );
        thumbs.forEach(function (t) {
          t.addEventListener('click', function () {
            thumbs.forEach(function (b) {
              var on = b === t;
              b.classList.toggle('is-active', on);
              b.setAttribute('aria-pressed', on ? 'true' : 'false');
            });
            if (main && t.dataset.full) {
              main.src = t.dataset.full;
              main.removeAttribute('srcset');
              if (t.getAttribute('aria-label')) main.alt = t.getAttribute('aria-label');
            }
          });
        });
      }

      /* ---- no colour products: fall back to plain visual toggling ----
         fabricWrap is included here too. It was missing, which meant a broken
         payload left the fabric buttons with no handler at all. */
      if (!data || !data.swatches || !data.swatches.length) {
        warn(
          'running in visual-only mode: no colour products in the payload. ' +
          'Selectors will highlight but will not change product, price or checkout link.',
          {
            hasPayload: !!data,
            payloadType: Object.prototype.toString.call(data),
            payloadKeys: (data && typeof data === 'object') ? Object.keys(data) : '(none)',
            swatchesType: Object.prototype.toString.call(data && data.swatches),
            swatchesLength: data && data.swatches && data.swatches.length,
            swatchesInDom: swatchWrap ? swatchWrap.querySelectorAll('.b8r-swatch').length : 0,
            fabricsInDom: fabricWrap ? fabricWrap.querySelectorAll('.b8r-fabrics__btn').length : 0
          }
        );
        [sizeWrap, swatchWrap, fabricWrap].forEach(function (wrap) {
          if (!wrap) return;
          var group = Array.prototype.slice.call(wrap.children);
          group.forEach(function (btn) {
            btn.addEventListener('click', function () {
              group.forEach(function (b) {
                b.classList.toggle('is-active', b === btn);
                b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
              });
            });
          });
        });
        bindThumbs();
        return;
      }

      var state = { colour: null, variant: null };
      root.__b8rState = state;   /* inspectable from the console */

      /* Fabric badge = a fixed uplift over the baseline fabric, at the size
         currently selected. The baseline is the FIRST fabric in the row (block
         order) and never carries a badge; every other fabric always shows its
         difference against it, whether or not it is the one selected. Each
         fabric is represented by its first colour, so the figure does not move
         as the shopper changes colour — only size changes it. */
      function paintFabricBadges() {
        if (!fabricWrap) return;

        var buttons = Array.prototype.slice
          .call(fabricWrap.querySelectorAll('.b8r-fabrics__btn'));
        if (!buttons.length) return;

        var baseline = buttons[0].dataset.fabric;
        var size = state.variant && state.variant.title;

        function firstColourOf(fabric) {
          for (var i = 0; i < data.swatches.length; i++) {
            if (data.swatches[i].fabric === fabric) return data.swatches[i];
          }
          return null;
        }
        function priceOf(colour, title) {
          if (!colour || !title) return null;
          for (var i = 0; i < colour.variants.length; i++) {
            if (colour.variants[i].title === title) {
              var c = colour.variants[i].priceCents;
              return typeof c === 'number' ? c : null;
            }
          }
          return null;
        }

        var baseColour = firstColourOf(baseline);
        var basePrice = priceOf(baseColour, size);

        buttons.forEach(function (btn) {
          var badge = btn.querySelector('[data-fabric-badge]');
          if (!badge) return;
          var fabric = btn.dataset.fabric;

          function hide(why) {
            badge.hidden = true;
            badge.textContent = '';
            if (why) log('  badge', JSON.stringify(fabric), 'hidden —', why);
          }

          if (fabric === baseline) return hide();          /* baseline: never */
          if (!size) return hide('nothing selected');
          if (basePrice === null) {
            return hide('baseline ' + JSON.stringify(baseline) + ' has no ' + size);
          }

          var colour = firstColourOf(fabric);
          var price = priceOf(colour, size);
          if (price === null) {
            return hide((colour ? colour.label : fabric) + ' has no ' + size);
          }

          var delta = price - basePrice;
          if (delta === 0) return hide('same price as ' + baseline);

          badge.textContent = (delta > 0 ? '+' : '\u2212') +
                              formatMoney(delta, data.moneyFormat);
          badge.hidden = false;
          log('  badge', JSON.stringify(fabric), '=', badge.textContent,
              '(' + colour.label + ' ' + size + ' vs ' + baseColour.label + ' ' + size + ')');
        });
      }

      function paintPrice() {
        var v = state.variant;
        paintFabricBadges();
        if (!v) return;

        /* innerHTML, not textContent: this shop's money_format wraps prices in
           <span class="money">, which the currency converter and Discount Ninja
           both hook. The strings come from Liquid's money filter, so this is
           shop-controlled markup, and it keeps a swapped price identical to a
           server-rendered one. Only overwrite when the payload carries a value,
           so a gap in the data cannot blank out a correct price. */
        if (priceEl && v.price) priceEl.innerHTML = v.price;

        /* Slash price and pill come only from the variant's own compare-at
           price. No markdown means both are hidden — never a typed literal,
           which would be in the wrong currency and would be a false former
           price. */
        if (compareEl) {
          compareEl.innerHTML = v.compare || '';
          compareEl.hidden = !v.compare;
        }
        if (pillEl) {
          pillEl.textContent = v.discount || '';
          pillEl.hidden = !v.discount;
        }
        log('paint', {
          colour: state.colour && (state.colour.fabric + ' / ' + state.colour.label),
          size: v.title,
          variant: v.id,
          price: v.price,
          compare: v.compare || '(none)',
          discount: v.discount || '(none)',
          available: v.available
        });
        if (cta) {
          if (v.available) {
            cta.href = data.checkoutBase + '/' + v.id + ':1';
            cta.classList.remove('is-disabled');
            cta.removeAttribute('aria-disabled');
            if (ctaLabel) ctaLabel.textContent = data.ctaText;
          } else {
            cta.removeAttribute('href');
            cta.classList.add('is-disabled');
            cta.setAttribute('aria-disabled', 'true');
            if (ctaLabel) ctaLabel.textContent = data.soldOutText;
          }
        }
      }

      function paintSizes() {
        if (!sizeWrap || !state.colour) return;
        sizeWrap.textContent = '';
        state.colour.variants.forEach(function (v) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'b8r-sizes__btn';
          if (state.variant && v.id === state.variant.id) btn.classList.add('is-active');
          if (!v.available) btn.classList.add('is-soldout');
          btn.setAttribute('role', 'radio');
          btn.setAttribute('aria-checked', state.variant && v.id === state.variant.id ? 'true' : 'false');
          btn.setAttribute('data-option-name', 'Size');
          btn.setAttribute('data-option-value', v.title);
          btn.setAttribute('data-variant-id', String(v.id));
          if (!v.available) btn.setAttribute('aria-disabled', 'true');
          btn.textContent = v.title;
          btn.addEventListener('click', function () {
            if (!v.available) {
              log('size click IGNORED —', v.title, 'is sold out for', state.colour.label);
              return;
            }
            log('size ->', v.title, '(variant ' + v.id + ')');
            state.variant = v;
            paintSizes();
            paintPrice();
          });
          sizeWrap.appendChild(btn);
        });
      }

      function paintGallery() {
        var images = state.colour && state.colour.images;
        if (!thumbWrap || !images || !images.length) return;
        thumbWrap.textContent = '';
        images.forEach(function (img, i) {
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'b8r-gallery__thumb' + (i === 0 ? ' is-active' : '');
          btn.setAttribute('aria-label', 'Photo ' + (i + 1));
          btn.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
          btn.setAttribute('data-full', img.full);
          var el = document.createElement('img');
          el.src = img.thumb;
          el.alt = '';
          el.loading = 'lazy';
          btn.appendChild(el);
          btn.addEventListener('click', function () {
            Array.prototype.slice
              .call(thumbWrap.querySelectorAll('.b8r-gallery__thumb'))
              .forEach(function (b) {
                var on = b === btn;
                b.classList.toggle('is-active', on);
                b.setAttribute('aria-pressed', on ? 'true' : 'false');
              });
            if (main) {
              main.src = img.full;
              main.removeAttribute('srcset');
              main.alt = btn.getAttribute('aria-label') || main.alt;
            }
          });
          thumbWrap.appendChild(btn);
        });
        if (main) {
          main.src = images[0].full;
          main.removeAttribute('srcset');
          if (images[0].alt) main.alt = images[0].alt;
        }
      }

      function selectColour(colour, keepSizeTitle) {
        log('colour ->', colour.fabric + ' / ' + colour.label,
            '(' + colour.handle + ')', { keepSize: keepSizeTitle || '(none)' });
        state.colour = colour;

        /* keep the shopper on the same size across a colour change when that
           colour stocks it, otherwise fall back to the first available one */
        var match = null;
        if (keepSizeTitle) {
          colour.variants.forEach(function (v) {
            if (!match && v.title === keepSizeTitle && v.available) match = v;
          });
        }
        state.variant = match || preferredVariant(colour.variants, data.preferredSize);

        Array.prototype.slice
          .call(swatchWrap ? swatchWrap.querySelectorAll('.b8r-swatch') : [])
          .forEach(function (b) {
            var on = b.dataset.colourId === colour.id;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-checked', on ? 'true' : 'false');
          });

        /* the fabric row follows the colour, and only that fabric's swatches
           are on show — Standard and Bouclé do not share a colour range */
        if (fabricWrap) {
          Array.prototype.slice
            .call(fabricWrap.querySelectorAll('.b8r-fabrics__btn'))
            .forEach(function (b) {
              var on = b.dataset.fabric === colour.fabric;
              b.classList.toggle('is-active', on);
              b.setAttribute('aria-checked', on ? 'true' : 'false');
            });
        }
        if (swatchWrap) {
          Array.prototype.slice
            .call(swatchWrap.querySelectorAll('.b8r-swatch'))
            .forEach(function (b) {
              b.hidden = b.dataset.fabric !== colour.fabric;
            });
        }

        /* show this colour's Judge.me badge, hide the others. They are all
           already initialised, so this is a visibility flip, not a re-render */
        if (ratingWrap) {
          Array.prototype.slice
            .call(ratingWrap.querySelectorAll('[data-colour-id]'))
            .forEach(function (el) {
              el.hidden = el.dataset.colourId !== colour.id;
            });
        }

        paintGallery();
        paintSizes();
        paintPrice();
      }

      /* ---- initial state: the swatch the server marked active ---- */
      var byId = {};
      data.swatches.forEach(function (c) { byId[c.id] = c; });

      var activeSwatch = swatchWrap && swatchWrap.querySelector('.b8r-swatch.is-active');
      var initial = (activeSwatch && byId[activeSwatch.dataset.colourId]) || data.swatches[0];
      state.colour = initial;

      var activeSize = sizeWrap && sizeWrap.querySelector('.b8r-sizes__btn.is-active');
      var initialId = activeSize && activeSize.dataset.variantId;
      initial.variants.forEach(function (v) {
        if (String(v.id) === String(initialId)) state.variant = v;
      });
      if (!state.variant) state.variant = preferredVariant(initial.variants, data.preferredSize);

      /* ---- startup report, plus a check that every control has data behind
         it. A fabric button with no matching colour, or a swatch whose id is
         not in the payload, is silently dead on click — exactly the reported
         symptom, so it is called out loudly. ---- */
      log('wired', {
        section: root.id || '(no id)',
        swatches: data.swatches.length,
        fabrics: data.swatches.map(function (c) { return c.fabric; })
          .filter(function (v, i, a) { return a.indexOf(v) === i; }),
        checkoutBase: data.checkoutBase,
        preferredSize: data.preferredSize
      });

      data.swatches.forEach(function (c) {
        var avail = c.variants.filter(function (v) { return v.available; }).length;
        log('  colour', c.fabric + ' / ' + c.label, {
          handle: c.handle,
          images: c.images.length,
          variants: c.variants.length,
          inStock: avail,
          sizes: c.variants.map(function (v) {
            return v.title + (v.available ? '' : ' (SOLD OUT)');
          })
        });
        if (!c.variants.length) {
          warn('colour "' + c.label + '" (' + c.handle + ') has no variants — ' +
               'selecting it clears the sizes and leaves the price unchanged');
        } else if (!avail) {
          warn('colour "' + c.label + '" (' + c.handle + ') is entirely out of ' +
               'stock — none of its sizes will be clickable');
        }
      });

      if (fabricWrap) {
        Array.prototype.slice
          .call(fabricWrap.querySelectorAll('.b8r-fabrics__btn'))
          .forEach(function (btn) {
            var f = btn.dataset.fabric;
            var n = data.swatches.filter(function (c) { return c.fabric === f; }).length;
            log('  fabric button', JSON.stringify(f), '->', n, 'colour(s)');
            if (!n) {
              warn('fabric button ' + JSON.stringify(f) + ' has no colours in the ' +
                   'payload, so clicking it does nothing. Its colour blocks are ' +
                   'probably missing a product, or the product did not resolve ' +
                   '(unpublished, or absent from this market). Check the fabric ' +
                   'value matches EXACTLY, accents included.');
            }
          });
      } else {
        log('  no fabric row rendered (all colour blocks share one fabric value)');
      }

      if (swatchWrap) {
        Array.prototype.slice
          .call(swatchWrap.querySelectorAll('.b8r-swatch'))
          .forEach(function (btn) {
            if (!byId[btn.dataset.colourId]) {
              warn('swatch ' + JSON.stringify(btn.getAttribute('data-option-value')) +
                   ' has no payload entry (block id ' + btn.dataset.colourId +
                   '), so clicking it does nothing');
            }
          });
      }

      /* The server already painted this state for the no-JS case, but repaint
         from the same object that builds the checkout link so the price, the
         slash price and the pill can never disagree with the variant being
         bought — including when the server fell back to the typed values. */
      paintSizes();
      paintPrice();
      bindThumbs();

      if (fabricWrap) {
        Array.prototype.slice
          .call(fabricWrap.querySelectorAll('.b8r-fabrics__btn'))
          .forEach(function (btn) {
            btn.addEventListener('click', function () {
              var want = btn.dataset.fabric;
              var current = state.colour && state.colour.label;

              /* stay on the same colour name when the new fabric offers it —
                 Grey exists in both ranges — otherwise take its first colour */
              var sameName = null;
              var firstOfFabric = null;
              data.swatches.forEach(function (c) {
                if (c.fabric !== want) return;
                if (!firstOfFabric) firstOfFabric = c;
                if (!sameName && current && c.label === current) sameName = c;
              });

              var next = sameName || firstOfFabric;
              log('fabric click', JSON.stringify(want), {
                currentColour: current,
                keptSameName: !!sameName,
                resolvedTo: next && (next.fabric + ' / ' + next.label)
              });
              if (next) {
                selectColour(next, state.variant && state.variant.title);
              } else {
                warn('fabric ' + JSON.stringify(want) + ' resolved to no colour, ' +
                     'so nothing switched. Payload fabrics are: ' +
                     data.swatches.map(function (c) { return JSON.stringify(c.fabric); }).join(', '));
              }
            });
          });
      }

      if (swatchWrap) {
        Array.prototype.slice
          .call(swatchWrap.querySelectorAll('.b8r-swatch'))
          .forEach(function (btn) {
            btn.addEventListener('click', function () {
              var colour = byId[btn.dataset.colourId];
              log('swatch click', JSON.stringify(btn.getAttribute('data-option-value')),
                  { colourId: btn.dataset.colourId, found: !!colour });
              if (!colour) {
                /* a swatch with no product picked: toggle the ring only */
                Array.prototype.slice
                  .call(swatchWrap.querySelectorAll('.b8r-swatch'))
                  .forEach(function (b) {
                    b.classList.toggle('is-active', b === btn);
                    b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
                  });
                return;
              }
              selectColour(colour, state.variant && state.variant.title);
            });
          });
      }
    }

    function scan(root) {
      var scope = root || document;
      Array.prototype.slice
        .call(scope.querySelectorAll('[data-b8r-buybox]'))
        .forEach(wire);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { scan(); });
    } else {
      scan();
    }

    document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dfc-bed-listicle"] && !Shopify.designMode) return;
  try {
    
function initDfcBed(){const root=document.getElementById('dfc-bed');if(!root||root.dataset.ready)return;root.dataset.ready='true';root.querySelectorAll('.swatch').forEach(button=>button.addEventListener('click',()=>{root.querySelectorAll('.swatch').forEach(b=>{b.classList.remove('selected');b.setAttribute('aria-pressed','false')});button.classList.add('selected');button.setAttribute('aria-pressed','true');const img=root.querySelector('#product-image');img.src=button.dataset.image;img.alt=button.dataset.alt;root.querySelector('#colour-name').textContent=button.dataset.name}));}initDfcBed();document.addEventListener('DOMContentLoaded',initDfcBed);document.addEventListener('shopify:section:load',initDfcBed);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eam-51-buybox"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';
    function qs(sel, root) { return (root || document).querySelector(sel); }
    function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

    function scrollToEl(el) {
      if (!el) return;
      scrollTo({ top: el.getBoundingClientRect().top + pageYOffset - 16, behavior: 'smooth' });
    }

    function formatMoney(cents, locale) {
      if (typeof cents !== 'number' || isNaN(cents)) return '';
      return (window.Shopify && typeof Shopify.formatMoney === 'function')
        ? Shopify.formatMoney(cents, locale && locale.moneyFormat)
        : new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: (locale && locale.currency) || 'USD' }).format(cents / 100);
    }

    function initBuybox(root) {
      if (root.__eam51) return;
      root.__eam51 = true;

      var sectionId = root.getAttribute('data-eam51-buybox');
      var product = null;
      var jsonNode = document.querySelector('[data-eam51-product-json="' + sectionId + '"]');
      if (jsonNode) {
        try { product = JSON.parse(jsonNode.textContent); } catch (e) { console.warn('EAM buy box: could not read product data.', e); }
      }
      var variants = (product && Array.isArray(product.variants)) ? product.variants : [];

      var locale = null;
      var localeNode = document.querySelector('[data-eam51-locale-json="' + sectionId + '"]');
      if (localeNode) {
        try { locale = JSON.parse(localeNode.textContent); } catch (e) { console.warn('EAM buy box: could not read locale data.', e); }
      }

      // Which variant option index is Size, and which is the box/qty option.
      // Read by name rather than assumed position, so it works whichever
      // order the merchant set the product's options up in.
      var sizeIndex = 0, boxIndex = 1;
      if (product && Array.isArray(product.options)) {
        var found = product.options.findIndex(function (name) { return String(name).toLowerCase().indexOf('size') !== -1; });
        if (found !== -1) {
          sizeIndex = found;
          boxIndex = found === 0 ? 1 : 0;
        }
      }
      function optionValue(variant, index) {
        return Array.isArray(variant.options) ? variant.options[index] : null;
      }
      function findVariant(size, boxes) {
        return variants.find(function (v) {
          return optionValue(v, sizeIndex) === size && (boxes == null || optionValue(v, boxIndex) === boxes);
        }) || null;
      }

      var onSize = qs('.k-dfc-size.is-on', root);
      var onBundle = qs('.k-dfc-bundle__opt.is-on', root);
      var state = {
        size: onSize ? onSize.getAttribute('data-size') : null,
        boxes: onBundle ? onBundle.getAttribute('data-boxes') : null
      };

      var slidesList = function () { return qsa('.k-dfc-gallery__slide', root); };
      var slide = 0;

      function showSlide(i) {
        var list = slidesList();
        if (!list.length) return;
        slide = (i + list.length) % list.length;
        list.forEach(function (s, n) {
          var isOn = n === slide;
          s.classList.toggle('is-on', isOn);
          var video = s.querySelector('video');
          if (video) {
            if (isOn) {
              video.muted = true;
              video.play().catch(function () {});
            } else {
              video.pause();
            }
          }
        });
        var cur = qs('.k-dfc-gallery__current', root);
        if (cur) cur.textContent = String(slide + 1);
        var p = qs('.k-dfc-gallery__arrow--prev', root), n = qs('.k-dfc-gallery__arrow--next', root);
        if (p) p.classList.toggle('is-off', slide === 0);
        if (n) n.classList.toggle('is-off', slide === list.length - 1);
        qsa('.k-dfc-gallery__thumb', root).forEach(function (t, k) { t.classList.toggle('is-on', k === slide); });
      }

      var currentVariant = null;

      function render() {
        // Every box option, priced for the size that's currently selected —
        // so switching size can never leave a bundle button showing another
        // size's price.
        qsa('.k-dfc-bundle__opt', root).forEach(function (btn) {
          var boxes = btn.getAttribute('data-boxes');
          var variant = findVariant(state.size, boxes);
          var priceEl = qs('[data-kd="bundle-price"]', btn);
          if (variant && priceEl) {
            priceEl.textContent = formatMoney(variant.price, locale);
          }
          btn.disabled = !variant || !variant.available;
          btn.classList.toggle('is-soldout', !variant || !variant.available);
        });

        currentVariant = findVariant(state.size, state.boxes);
        var cta = qs('[data-kd="cta"]', root);
        var ctaPrice = qs('[data-kd="cta-price"]', root);
        var ctaWas = qs('[data-kd="cta-was"]', root);
        if (currentVariant) {
          if (ctaPrice) ctaPrice.textContent = formatMoney(currentVariant.price, locale);
          if (ctaWas) {
            if (currentVariant.compare_at_price > currentVariant.price) {
              ctaWas.textContent = formatMoney(currentVariant.compare_at_price, locale);
              ctaWas.hidden = false;
            } else {
              ctaWas.hidden = true;
            }
          }
          if (cta) cta.disabled = !currentVariant.available;
        } else if (cta) {
          cta.disabled = true;
        }

        var sizeBtn = qs('.k-dfc-size[data-size="' + (window.CSS && CSS.escape ? CSS.escape(state.size || '') : state.size) + '"]', root);
        if (sizeBtn) {
          var width = sizeBtn.getAttribute('data-width'), length = sizeBtn.getAttribute('data-length');
          var breeds = qs('[data-kd="fit-breeds"]', root);
          if (breeds) breeds.innerHTML = '<b>' + sizeBtn.getAttribute('data-size') + '</b> fits a paw pad about ' + width + ' wide and ' + length + ' long. Common breeds:';
          var chips = qs('[data-kd="fit-chips"]', root);
          if (chips) {
            var html = '';
            ['1', '2'].forEach(function (n) {
              var name = sizeBtn.getAttribute('data-breed-' + n);
              if (!name) return;
              var img = sizeBtn.getAttribute('data-breed-' + n + '-img');
              var pic = img ? '<img src="' + img + '" alt="" width="32" height="32">' : '<span class="k-dfc-chip__ph" aria-hidden="true"></span>';
              html += '<span class="k-dfc-chip">' + pic + name + '</span>';
            });
            chips.innerHTML = html;
          }
        }
      }

      qsa('.k-dfc-size', root).forEach(function (b) {
        b.addEventListener('click', function () {
          state.size = b.getAttribute('data-size');
          qsa('.k-dfc-size', root).forEach(function (x) { x.classList.toggle('is-on', x === b); });
          var v = qs('[data-kd="size-value"]', root);
          if (v) v.textContent = state.size;
          render();
        });
      });

      qsa('.k-dfc-bundle__opt', root).forEach(function (b) {
        b.addEventListener('click', function () {
          if (b.disabled) return;
          state.boxes = b.getAttribute('data-boxes');
          qsa('.k-dfc-bundle__opt', root).forEach(function (x) {
            x.classList.toggle('is-on', x === b);
            x.setAttribute('aria-pressed', x === b ? 'true' : 'false');
          });
          render();
        });
      });

      var prev = qs('.k-dfc-gallery__arrow--prev', root), next = qs('.k-dfc-gallery__arrow--next', root);
      if (prev) prev.addEventListener('click', function () { showSlide(slide - 1); });
      if (next) next.addEventListener('click', function () { showSlide(slide + 1); });
      qsa('.k-dfc-gallery__thumb', root).forEach(function (t, i) { t.addEventListener('click', function () { showSlide(i); }); });

      // Drag/swipe the stage itself (mouse, touch and pen, via Pointer Events)
      // to move between slides, same as the arrows and thumbnails.
      var stage = qs('.k-dfc-gallery__stage', root);
      if (stage && window.PointerEvent) {
        var drag = null;
        var DRAG_THRESHOLD = 40;

        stage.addEventListener('dragstart', function (e) { e.preventDefault(); });

        stage.addEventListener('pointerdown', function (e) {
          if (e.target.closest('button')) return;
          drag = { startX: e.clientX, pointerId: e.pointerId };
          stage.setPointerCapture(e.pointerId);
          stage.classList.add('is-dragging');
        });

        stage.addEventListener('pointerup', function (e) {
          if (!drag || drag.pointerId !== e.pointerId) return;
          var dx = e.clientX - drag.startX;
          drag = null;
          stage.classList.remove('is-dragging');
          if (Math.abs(dx) > DRAG_THRESHOLD) showSlide(slide + (dx < 0 ? 1 : -1));
        });

        stage.addEventListener('pointercancel', function () {
          drag = null;
          stage.classList.remove('is-dragging');
        });
      }

      qsa('[data-kd-jump]', root).forEach(function (b) {
        b.addEventListener('click', function () {
          var sel = b.getAttribute('data-kd-jump');
          if (sel) scrollToEl(document.querySelector(sel));
        });
      });

      var chartBtn = qs('[data-kd="open-chart"]', root);
      var modal = qs('.k-dfc-modal[data-kd-modal="chart"]');
      if (chartBtn && modal) chartBtn.addEventListener('click', function () { modal.classList.add('is-open'); });
      if (modal) {
        qsa('[data-kd-close]', modal).forEach(function (b) { b.addEventListener('click', function () { modal.classList.remove('is-open'); }); });
        modal.addEventListener('click', function (e) { if (e.target === modal) modal.classList.remove('is-open'); });
      }
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal) modal.classList.remove('is-open');
      });

      function goToCart() {
        if (!currentVariant || !currentVariant.available) return;
        var root2 = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
        window.location.href = root2 + 'cart/' + currentVariant.id + ':1';
      }
      var cta = qs('[data-kd="cta"]', root);
      if (cta) cta.addEventListener('click', goToCart);

      render();
      showSlide(0);
    }

    function boot() {
      qsa('[data-eam51-buybox]').forEach(initBuybox);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eam-lp-reviews"] && !Shopify.designMode) return;
  try {
    
  // The reference's own mechanism: a class on the wrapper, which its CSS reads.
  // Nothing here sets a size, a position or a colour.
  document.querySelectorAll('.bcx-revsec').forEach(function (root) {
    var wrap = root.querySelector('[data-eam-reviews]');
    if (!wrap) return;
    var track = wrap.querySelector('.dfc-reviews__track');
    var more = root.querySelector('[data-eam-rev-more]');

    function setExpanded(on) {
      wrap.classList.toggle('is-expanded', on);
      if (more) {
        more.setAttribute('aria-expanded', on ? 'true' : 'false');
        if (more.dataset.lessText) {
          more.textContent = on ? 'See fewer reviews':'See more reviews';
        }
      }
    }

    setExpanded(false);

    if (more) {
      more.addEventListener('click', function () {
        setExpanded(more.getAttribute('aria-expanded') !== 'true');
      });
    }

    function step(dir) {
      if (!track) return;
      var first = track.querySelector('.shp2-rev');
      var by = first ? first.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
      track.scrollBy({ left: dir * by, behavior: 'smooth' });
    }

    var prev = wrap.querySelector('[data-eam-rev-prev]');
    var next = wrap.querySelector('[data-eam-rev-next]');
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eam-lp-sticky-bar"] && !Shopify.designMode) return;
  try {
    
  // The bar is position:fixed at opacity 0 with pointer-events none until it
  // carries .stk--on, which is the state the reference's CSS reveals, so
  // without this it would never appear. data-stk-arm-enter names the section it
  // arms from; with no match, or no IntersectionObserver, the bar just shows.
  document.querySelectorAll('[data-stk]').forEach(function (bar) {
    var sel = bar.getAttribute('data-stk-arm-enter');
    var target = sel ? document.querySelector(sel) : null;

    // The bar is position:fixed, so the section's own wrapper collapses to
    // nothing and the page ends underneath the bar. Give the wrapper the bar's
    // height so it reserves exactly the space the bar covers. The height is not
    // a constant: the button is 64px, but the trust row reflows at 490px and
    // again at 480px, and the padding picks up the iOS safe-area inset. So it
    // is measured rather than hardcoded, and re-measured when it changes.
    var wrap = bar.closest('.eam-lp') || bar.parentElement;

    function reserve() {
      if (wrap) wrap.style.height = bar.offsetHeight + 'px';
    }

    reserve();
    if ('ResizeObserver' in window) {
      new ResizeObserver(reserve).observe(bar);
    } else {
      window.addEventListener('resize', reserve);
    }

    function show(on) { bar.classList.toggle('stk--on', on); }

    if (!target || !('IntersectionObserver' in window)) {
      show(true);
      return;
    }

    // armed once the top of the named section has been scrolled past
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        show(entry.boundingClientRect.top < 0 || entry.isIntersecting);
      });
    }, { threshold: 0 }).observe(target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      var height = 0;
      document.querySelectorAll('.shopify-section-group-header-group').forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom > 0 && rect.top < 200) {
          height = Math.max(height, Math.round(rect.bottom));
        }
      });
      if (!height) {
        var header = this.header || document.querySelector('.section-header');
        if (header) {
          height = Math.max(header.offsetHeight || 0, Math.round(header.getBoundingClientRect().bottom));
        }
      }
      document.documentElement.style.setProperty('--header-height', `${Math.max(0, height)}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
